<template>
	<v-container class="mt-4 ml-2">
	  <v-row>
	  	<v-col cols="12" md="10" lg="8">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Cómo nos conocio</span>
	  		    <v-spacer></v-spacer>
	  		    <v-btn
              color="primary"
              dark
              class="mb-2"
              @click="dialog = true"
              small
              rounded
            >
              Nuevo medio
            </v-btn>
	  		  </v-card-title>

	  		  <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="6">
                <v-text-field
                  dense
                  hide-details
                  label="Buscar"
                  filled
                  v-model="search"
                ></v-text-field>
              </v-col>
            </v-row>
	  		    
					  <v-data-table
					    :headers="headers"
					    :items="mediocontacto"
					    class="elevation-0"
              :search="search"
					  >					    
					    <!-- Valores que ocupan botons, chips, iconos, etc -->
					    <template v-slot:item.estatus="{ item }">
					      <v-chip 
					      	v-if="item.estatus == 1"
					      	small
					      	color="green"
					      	dark
					      >Activo</v-chip>

					      <v-chip 
					      	v-else
					      	small
					      	color="error"
					      	dark
					      >Inactivo</v-chip>
					    </template>

					    <template v-slot:item.color="{ item }">
					      <v-chip 
					      	small
					      	:color="item.color"
					      	dark
					      ></v-chip>
					    </template>

					    <template v-slot:item.actions="{ item }">
					      <v-icon
					        small
					        class="mr-2"
					        color="primary"
					        @click="editItem(item)"
					      >
					        mdi-pencil
					      </v-icon>
					      <v-icon
					        small
					        @click="deleteItem(item)"
					        color="error"
					      >
					        mdi-delete
					      </v-icon>
					    </template>

					    <template v-slot:no-data>
					      <v-btn
					        color="primary"
					        @click="initialize"
					        small
					      >
					        Actualizar
					      </v-btn>
					    </template>
					  </v-data-table>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="editedItem.medio"
            label="medio"
            filled
            autofocus
            dense
          ></v-text-field>

        	<v-switch 
        		label="Activo"
            hide-details
        		v-model="editedItem.estatus"
          ></v-switch>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            class="elevation-6"
            dark
            @click="save"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row>
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-h6" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar la información?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text large class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C" dark class="elevation-6" large @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="6">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>


		<!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores  from '@/mixins/validarErrores'
  import funcionesExcel  from '@/mixins/funcionesExcel'


  export default {

  	components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores, funcionesExcel ],

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      headers: [
        { text: 'ID'     , align: 'start', sortable: false, value: 'idmedio_contacto', },
        { text: 'Medio'  , value: 'medio' },
        { text: 'Estatus', value: 'estatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      mediocontacto: [],
      editedIndex: -1,
      editedItem: {
        idmedio_contacto: '',
        medio: '',
        estatus: '',
      },
      defaultItem: {
        idmedio_contacto: '',
        medio: '',
        estatus: '',
      },
      search:''
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar medio' : 'Editar medio'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.mediocontacto = []
        this.cargar = true
        this.$http.get('mediocontacto.list').then(response=>{
        	this.mediocontacto = response.data
        	this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.mediocontacto.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.mediocontacto.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('mediocontacto.update/' + this.editedItem.idmedio_contacto, this.editedItem).then(response=>{
        	this.cargar = false
          this.validarSuccess('Datos elimniados correctamente')
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
      	if(this.editedItem.medio == ''){
      		this.validarErrorDirecto ( 'Favor de llenar todos los campos' )
	        return
      	}

        if (this.editedIndex > -1) {
          // Activamos el loader
	        this.cargar = true
	        // Lo mandapos por el EP
          this.$http.put('mediocontacto.update/' + this.editedItem.idmedio_contacto, this.editedItem).then(response=>{
          	this.validarSuccess('Datos actualizados correctamente')
          	this.initialize()
	        	this.cargar = false
	        }).catch( error =>{
	          this.validarError( error.response.data.message )
	        }).finally( () => { this.cargar = false })

        } else {
        	// Activamos el loader
	        this.cargar = true
	        // Lo mandapos por el EP
          this.$http.post('mediocontacto.add', this.editedItem).then(response=>{
          	this.validarSuccess('Datos agregados correctamente')
          	this.initialize()
	        	this.cargar = false
	        }).catch( error =>{
	          this.validarError( error.response.data.message )
	        }).finally( () => { this.cargar = false })
        }
        this.close()
      },
    },
  }
/*433*/
</script>
